import { render, staticRenderFns } from "./TestingTemplates.vue?vue&type=template&id=0cf34ecb&scoped=true"
import script from "./TestingTemplates.vue?vue&type=script&lang=js"
export * from "./TestingTemplates.vue?vue&type=script&lang=js"
import style0 from "./TestingTemplates.vue?vue&type=style&index=0&id=0cf34ecb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf34ecb",
  null
  
)

export default component.exports